import {ContactStep} from '@/components/trademark-verification/steps/ContactStep'
import {MarketsStep} from '@/components/trademark-verification/steps/MarketsStep'
import {TrademarkStep} from '@/components/trademark-verification/steps/TrademarkStep'
import {
  verificationContactInfoSchema,
  verificationMarketsValiditySchema,
  verificationTrademarkTypeSchema,
} from '@/utils/validations/common/trademarkVerificationRequest'

export const useTrademarkVerificationSteps = (props: {
  ssrMobileDetected: boolean
  submitError: string | null
  isReturningCustomer: boolean
}) => ({
  steps: [
    {
      title: 'verification-step-trademark',
      validationSchema: verificationTrademarkTypeSchema,
      content: <TrademarkStep />,
    },
    {
      title: 'verification-step-markets',
      validationSchema: verificationMarketsValiditySchema,
      content: <MarketsStep ssrMobileDetected={props.ssrMobileDetected} />,
    },
    {
      title: 'verification-step-contact',
      validationSchema: verificationContactInfoSchema,
      content: (
        <ContactStep
          submitError={props.submitError}
          isReturningCustomer={props.isReturningCustomer}
        />
      ),
      isLastStep: true,
    },
  ],
})
